/**
 * @generated SignedSource<<340bfa986ef5a16ff676cbee2ad83596>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutUIReducer_transaction$data = {
  readonly warnings: {
    readonly isCheckoutBlocked: boolean | null;
  } | null;
  readonly " $fragmentType": "checkoutUIReducer_transaction";
};
export type checkoutUIReducer_transaction$key = {
  readonly " $data"?: checkoutUIReducer_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIReducer_transaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutUIReducer_transaction"
};

(node as any).hash = "ff091eeab6a768d647bbde3d7c7373d3";

export default node;
